import { Component, AfterViewInit } from '@angular/core';
import { DataService } from '../../../../../infrastructure/services/base/config/data.service';

declare var jQuery: any;

@Component({
    selector: 'page-user',
    templateUrl: './user.html',
})
export class UserComponent implements AfterViewInit {

    propertiesPage = {
        "Title": "",
        "TitleDesc": "",
        "BreadcrumbActive": "User"
    }

    UserList: any[];
    UserRow: any = null;
    arrCboGroup: any[];
    overLayBoxList: boolean = true;

    constructor(private dtService: DataService) { }

    getUserList(): void {
        this.dtService.getJSON("../../assets/mock-data/user-list.json")
            .subscribe(
            data => this.UserList = data.UserList,
            error => console.log(error),
            // () => console.log("Finished Call DeliveryTypes") 
        );
    }
    getUserGroup(): void {
        this.dtService.getJSON("../../assets/mock-data/user-group-list.json")
            .subscribe(
            data => this.arrCboGroup = data.UserGroupList,
            error => console.log(error),
            // () => console.log("Finished Call DeliveryTypes")
        );
    }

    ngOnInit(): void {
        this.getUserList();
    }

    ngAfterViewInit() {
        console.log(1);
    }

    btnSearchClick(): void {
        this.overLayBoxList = !this.overLayBoxList;
    }


    editRow(dt: any) {
        this.UserRow = dt;
    }




}


// WEBPACK FOOTER //
// ./src/app/views/pages/base/security/user/user.component.ts